import React, {FunctionComponent, useContext, useState} from 'react';
import {ChallengeContext, ChallengeContextProps} from '/src/contexts/ChallengeContext';
import {ChallengeProtocolData} from '/src/domain/challenges/ChallengeProtocolData';
import {InputAdornment, ButtonBase, OutlinedInput, LinearProgress} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import cs from 'classnames'
import SearchIcon from '@mui/icons-material/Search';
import {useTranslation} from 'react-i18next';


interface AuditSearchData {
    currentUserId?: string;
    handleAudit: (userId: string) => void;
}

const AuditSearch: FunctionComponent<AuditSearchData> = ({
                                                             currentUserId,
                                                             handleAudit
                                                         }) => {

    const {t} = useTranslation()
    const classes = useStyles()
    const [validation, setValidation] = useState(false);
    const {progress} = useContext(ChallengeContext) as ChallengeContextProps;

    const handleInput: (e: any) => void = (e) => {
        const reg = new RegExp('^\\d+$')
        e.target.value.search(reg) === -1 ? setValidation(true) : setValidation(false)
    }

    const handleSubmit: (e: any) => void = (e) => {
        e.preventDefault()
        if (!validation) handleAudit(e.target.userId.value)
    }
    return (
        <form onSubmit={handleSubmit} className={classes.container}>
            <OutlinedInput
                name={'userId'}
                placeholder={t('enterProfileId')}
                className={classes.outlinedInput}
                classes={{adornedEnd: classes.adornedEnd}}
                fullWidth
                autoComplete="off"
                onChange={handleInput}
                defaultValue={currentUserId}
                error={validation}
                endAdornment={
                    <InputAdornment position="end">
                        <ButtonBase disabled={validation} type="submit"
                                    className={cs(classes.searchBtn, {[classes.disabled]: validation})}>
                            <SearchIcon className={classes.searchIcon}/>
                            {t('audit')}
                        </ButtonBase>
                    </InputAdornment>
                }
            />
            {progress && <LinearProgress/>}
            {validation && <div className={classes.helperText}>{t('invalidValue')}</div>}
        </form>
    )
}

const useStyles = makeStyles((muiTheme) => ({
    container: {
        padding: '0 1.5rem',
        position: 'relative'
    },
    outlinedInput: {
        marginTop: '1rem',
        borderRadius: 0,
        height: '3rem',
        color: muiTheme.palette.primary.main,
        fontWeight: 400,
    },
    adornedEnd: {
        paddingRight: 0
    },
    searchBtn: {
        backgroundColor: muiTheme.palette.primary.main,
        color: muiTheme.palette.primary.contrastText,
        height: '3rem',
        padding: '0 1rem'
    },
    disabled: {
        filter: 'grayscale(100%)'
    },
    searchIcon: {
        marginRight: '0.5rem'
    },
    helperText: {
        backgroundColor: muiTheme.palette.primary.contrastText,
        padding: '0 0.2rem',
        fontSize: '0.7rem',
        position: 'absolute',
        left: '2.2rem',
        top: '3.5rem',
        color: '#f44336'
    }
}))

export default AuditSearch